import React from "react";
import { Matchmakers } from "../matchmakers";
import { MatchBasicProfile } from "./matchBasicProfile";
import { Link} from "react-router-dom";
import { useLocation } from "react-router-dom";
export function MatchEditProfile() {
    const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);

  return (
    <div className="matchMainContainer">
      <div className="matchEdit-subcontainer">
        <Link to="/matchmakers"> <div
          className="bi bi-arrow-left"
        
        ></div></Link>
       
        <div className="matchBasic-menu">
          <div>Basic Information</div>
        </div>
      </div>
      <div>
        <MatchBasicProfile userId={userId} />
      </div>
    </div>
  );
}
